// APIMart Nano Banana 2.1 Ext: one output per task, no official fallback.
// Pixel dimensions are reference sizes; the returned image is authoritative.
export const NANO_BANANA_21_SIZES = {
  'auto': {
    '1K': 'auto',
    '2K': 'auto',
    '4K': 'auto'
  },
  '1:1': {
    '1K': '1024x1024',
    '2K': '2048x2048',
    '4K': '4096x4096'
  },
  '1:4': {
    '1K': '512x2048',
    '2K': '1024x4096',
    '4K': '2048x8192'
  },
  '1:8': {
    '1K': '384x3072',
    '2K': '768x6144',
    '4K': '1536x12288'
  },
  '2:3': {
    '1K': '848x1264',
    '2K': '1696x2528',
    '4K': '3392x5056'
  },
  '3:2': {
    '1K': '1264x848',
    '2K': '2528x1696',
    '4K': '5056x3392'
  },
  '3:4': {
    '1K': '896x1200',
    '2K': '1792x2400',
    '4K': '3584x4800'
  },
  '4:1': {
    '1K': '2048x512',
    '2K': '4096x1024',
    '4K': '8192x2048'
  },
  '4:3': {
    '1K': '1200x896',
    '2K': '2400x1792',
    '4K': '4800x3584'
  },
  '4:5': {
    '1K': '928x1152',
    '2K': '1856x2304',
    '4K': '3712x4608'
  },
  '5:4': {
    '1K': '1152x928',
    '2K': '2304x1856',
    '4K': '4608x3712'
  },
  '8:1': {
    '1K': '3072x384',
    '2K': '6144x768',
    '4K': '12288x1536'
  },
  '9:16': {
    '1K': '768x1376',
    '2K': '1536x2752',
    '4K': '3072x5504'
  },
  '16:9': {
    '1K': '1376x768',
    '2K': '2752x1536',
    '4K': '5504x3072'
  },
  '21:9': {
    '1K': '1584x672',
    '2K': '3168x1344',
    '4K': '6336x2688'
  }
};
export const NANO_BANANA_21_CREDITS = { '1k': 5, '2k': 6, '4k': 8 };
export const NANO_BANANA_21_CAPABILITIES = {
  allowedAspectRatios: Object.keys(NANO_BANANA_21_SIZES),
  allowedResolutions: ['1K', '2K', '4K'],
  allowedSizesByAspect: NANO_BANANA_21_SIZES,
  allowedInputModes: ['text', 'image'],
  allowedImageFunctionModes: ['general', 'editing'],
  // Application guard inherited from Nano Banana 2; APIMart sets no fixed count.
  maxInputImages: 14,
  maxInputImageSizeMb: 20,
  maxTotalInputImageSizeMb: 50,
};
